interface DocumentCategory {
  id?: number;
  name?: string;
  companyId?: number;
}

export const newDocumentCategory = (): DocumentCategory => {
  return {};
};

export default DocumentCategory;
